export const TEMP_REDIRECT_URL = 'https://id.npck.kz/';
